
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//https://web.alotaxis.com/integration_test/api/
export const environment = {
  production: false,

  URL_BASE: 'https://net.alotaxis.com/integration_dev/api/',
  //URL_BASE: 'https://web.alotaxis.com/integration_test/api/',
  //URL_BASE: 'https://reporte-alotaxis.nexusvirtual.net/servicio-api-web/api/',
  URL_NOTIFICAR_CLIENTE_RESERVA:'https://web.alotaxis.com/wsnexusclientemovil_2_2_2/api/',
  URL_PAYU: 'https://web.alotaxis.com/ServicioPayu/api/',
  URL_GET_COUNTRY: 'https://ipinfo.io',
  //URL_NOTIFICACIONES: 'https://reportes-docker.nexusvirtual.net',
  URL_NOTIFICACIONES: 'https://reporte-alotaxis.nexusvirtual.net/',
  URL_EMAIL: 'https://web.alotaxis.com/src/assets/email',
  URL_ICON_MOVIL: 'assets/empresas/alo_taxi/img/markers/movil.png',
  URL_REPORTE_EXCEL:'https://reporte-alotaxis.nexusvirtual.net/reporte-alotaxi/', //'https://reportes-docker.nexusvirtual.net/reportes-usuariosTodos/reportes/usuariosTodos',

  PATH_TRACKING:'/tracking-node-alotaxi/socket.io/', //'/tracking-alotaxi/socket.io',
  LOGO: {
    URL: 'assets/empresas/alo_taxi/img/logos/logo-empresa-menu.svg',
    ALT: 'logo-empresa-menu'
  },
  URL_RECLAMOS: 'https://reportes-docker.nexusvirtual.net/alo-reclamos/',
  // URL_RECLAMOS: 'http://192.168.4.17:3000/',
  LOGO_INICIO_SESION: {
    URL: 'assets/empresas/alo_taxi/img/logos/logo-empresa.svg',
    URL2: 'assets/empresas/alo_taxi/img/foto_principal.png',
    ALT: 'logo-empresa'
  },
  COLOR_RUTA: "#008efb",
  COLOR_RUTA_MOBILE: "#EF494D",
  COLOR: {
    PRIMARY: "#EF494D",
    SECONDARY: "#f58721",
    KM: "#ffffff"
  },
  RECAPCHA: {
    SITEKEY: '6LfxUOYrAAAAAOpUREyFKZxsSQQ57ytUKkdZURWD',
  },
  ICON_BUSQUEDA: {
    ORIGEN: {
      URL: 'assets/empresas/alo_taxi/img/busqueda/origen.png',
      ALT: 'imagen-origen'
    },
    DESTINO: {
      URL: 'assets/empresas/alo_taxi/img/busqueda/destino.png',
      ALT: 'imagen-destino'
    },
    REFERENCIA: {
      URL: 'assets/empresas/alo_taxi/img/markers/referencia.svg',
      ALT: 'imagen-referencia'
    },
    CENTROCOSTO: {
      URL: 'assets/empresas/alo_taxi/img/markers/ceco.svg',
      ALT: 'imagen-ceco'
    },
    INSTRUCCION: {
      URL: 'assets/empresas/LEVEL_TAXI/img/markers/instruccion.png',
      ALT: 'imagen-instruccion'
    } 
  },
  TEST: 'assets/empresas/alo_taxi/img/busqueda/destino.png',
  MARKERS: {
    ORIGEN: {
      URL: 'assets/empresas/alo_taxi/img/markers/marker-origen.png',
      POSICION: 1,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    DESTINO: {
      URL: 'assets/empresas/alo_taxi/img/markers/marker-destino.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
   
   
    INSTRUCCION: {
      URL: 'assets/empresas/alo_taxi/img/markers/instruccion.png',
      ALT: 'imagen-instruccion'
    },

    TRAYECTO:{
      URL: 'assets/empresas/alo_taxi/img/markers/punto.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(20, 20)
    },

    CONTACTO: {
      URL: 'assets/empresas/alo_taxi/img/markers/simple_Icon.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    VELOCIDAD: {
      URL: 'assets/empresas/alo_taxi/img/markers/pin.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    CONDUCTOR: {
      URL: 'assets/empresas/alo_taxi/img/markers/ic_driver_top.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    CONDUCTOR_AUTO_LIBRE: {
      URL: 'assets/empresas/alo_taxi/img/markers/marker_verde.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_AUTO_SINGPS: {
      URL: 'assets/empresas/alo_taxi/img/markers/marker_gris.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_AUTO_OCUPADO: {
      URL: 'assets/empresas/alo_taxi/img/markers/marker_rojo.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    DRIVER: {
      URL: 'assets/empresas/alo_taxi/img/markers/ic_driver_top.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(56, 56)
    },

    
  },
  ESTADO: {
    ASIGNADO: 2,
    LEIDO: 3,
    CONTACTO: 5,
    INICIO: 6,
    TERMINADO: 7,
    LLEGO_DESTINO: 14,
    CANCELADO: 10,
    LIBRE: 1,
    PENDIENTE: 12,
    RECHAZADO: 9,
    OCUPADO:15,
    FIN_JORNADA:13,
    PREASIGNADO:16,
    ANULADO1: 8,
    ANULADO2: 9,
    ANULADO3: 10,
    SIN_SENIAL: -1
  },
  MODO_RESERVA: {
    BASE: 1,
    APLICATIVO: 2,
    WEB_API: 3,
    WEB: 4,
    COMUNIDAD: 5
  },
  TIPO_PAGO: {
    VALE: 1,
    EFECTIVO: 2,
    ABONO: 4,
    E_VALE: 6,
    TARJETA: 7,
    CORTESIA: 20,
    TIKECK_COUNTER: 21
  },
  TIPO_SERVICIO: {
    MOTO: 10,
    POR_TIEMPO: 5
  },
  TIEMPO_CONSULTAR_RUTA: 10000,
  TIEMPO_MINIMO_RESERVA:20,
  MENSAJES: {
    CONFIGURACION_PARAMETROS:{
      MSJ_ACTUALIZACION:'Su información se actualizo correctamente',
      MSJ_GUARDADO:'Su guardo correctamente'
    },
    SOLICITAR_SERVICIO: {
      MSJ_SERVICIO_CREADO: "Servicio creado correctamente.",
      MSJ_ERROR_DESCONOCIDO: "Ocurrio un problema, por favor intente nuevamente.",
      MSJ_SIN_PRESUPUESTO: "No cuenta con Presupuesto.",
      MSJ_VALIDACION_HORARIO: "No se puede realizar el servicio en el horario indicado.",
      MSJ_PRESUPUESTO_INACTIVO: "Presupuesto inactivo, elegir otro tipo de pago.",
      MSJ_EMPRESA_INACTIVA: "Empresa inactiva.",
      MSJ_EMPRESA_PRESUPUESTO_INACTIVO: "Empresa - Presupuesto Inactivo.",
      MSJ_CENTRO_COSTO_INACTIVO: "Centro Costo Inactivo.",
      MSJ_CENTRO_COSTO_PRESUPUESTO_INACTIVO: "Centro Costo - Presupuesto Inactivo.",
      MSJ_PRESUPUESTO_INACTIVO_CLIENTE: "Cliente - Presupuesto Inactivo.",
      MSJ_PRESUPUESTO_PLAZO_INCORRECTO: "El plazo solicitado es incorrecto, máximo 2 días de anticipación.",
      MSJ_NOTA_OBLIGATORIA: "El campo Nota 1 es obligatirio.",
      MSJ_USUARIO_NO_ENCONTRADO: "No se encontraron usuarios",
      MSJ_EMPRESA_NO_ENCONTRADA: "No se encontraron Empresas",
      MSJ_PRE_EMPRESA_NO_ENCONTRADA: "No se encontraron presupuestos de las Empresas",
      MSJ_CC_NO_ENCONTRADO: "No se encontraron Centros de Costos",
      MSJ_AREAS_NO_ENCONTRADA: "No se encontraron Áreas o Subáreas", 
      MSJ_MEJORAS_NO_ENCONTRADA: "No se encontraron registro de mejoras",
      MSJ_CALIFICACIONES_NO_ENCONTRADAS:"No se encontro registro de calificaciones",
      MSJ_RESTRICCION_SERVICIO:"Usted no esta autorizado para crear viajes"
    },
    CANCELAR_SERVICIO: {
      IDMOTIVO_CANCELACION:122,
      MSJ_CANCELAR_SERVICIO: "Cancelacion de busqueda de conductores.",
      MSJ_CANCELAR_SERVICIO_ENVIOS: "El servicio fue cancelado correctamente.",
      MSJ_CANCELAR_SERVICIO_ERROR:{
        MSJ_CANCELAR_SERRVICIO_SIN_IDSERVICIO:"No se envio el idServicio"
      }
    },
    SEDES: {
      MSJ_SEDE_NO_ENCONTRADA: "No se encontraron Sedes"
    },
    LOGIN: {
      USUARIO_INACTIVO: {
        CODIGO: -201,
        DESCRIPCION: 'Usuario inactivo'
      },
      NO_EXISTE_USUARIO: {
        CODIGO: -203,
        DESCRIPCION: 'No existe usuario'
      },
      CLAVE_INCORRECTA: {
        CODIGO: -202,
        DESCRIPCION: 'Contraseña incorrecta'
      },

      CLAVE_NO_ESTABLECIDA: {
        CODIGO: -204,
        DESCRIPCION: 'Contraseña no establecida'
      },
      ERROR: {
        CODIGO: -1,
        DESCRIPCION: 'Ocurrio un error'
      },
      CORREO_CORPORATIVO: {
        CODIGO: 1,
        DESCRIPCION: 'Correo enviado correctamente. Por favor revise su bandeja de entrada'
      },
      RECUPERAR_CONTRASENIA: {
        CODIGO: 1,
        DESCRIPCION: 'Recibiras en unos momentos un mensaje a su correo electrónico, indicando su contraseña.'
      },
      CORREO_DUPLICADO: {
        CODIGO: -6,
        DESCRIPCION: 'Su correo ya ha sido registrado'
      }
    },
    COMPARTIR_SERVICIO: {
      MSJ_SERVICIO_NO_ENCONTRADO: "NO SE ENCONTRÓ EL SERVICIO.",
      MSJ_SERVICIO_LIBRE: "Servicio creado",
      MSJ_SERVICIO_ASIGNADO: "su conductor está en camino",
      MSJ_SERVICIO_INICIO: "está en camino",
      MSJ_SERVICIO_TERMINO: "llegó a su destino"
    },
    ENVIOS: {
      MSJ_SIN_CONDUCTOR: "No se pudo obtener coordenadas del conductor.",
      MSJ_SIN_SERVICIOS: "No se encontraron servicios",
      MSJ_CALIFICACION_ESTRELLAS: "Se calificó correctamente al conductor.",
      MSJ_SERVICIOS_POR_CALIFICAR: "Tienes servicios por calificar, puede realizarlo desde 'Ver servicios'.",
      ERROR:{
        ERROR_CALIFICACION_ESTRELLAS: "Ocurrió un error al calificar; por favor intente mas tarde.",
      }
    },
    OCURRIO_PROBLEMA: {
      CODIGO: -1,
      DESCRIPCION: 'Ocurrio un problema, por favor intente nuevamente.'
    },
    METODO_PAGO: {
      TARJETA_CREADA: 'Se ha registrado su tarjeta correctamente',
    },
    PROMOCIONES: 'Validación exitosa',
    EXPORT_EXCEL: 'Se esta realizando la descarga, por favor espere',
    SERVICIOS_ENVIADOS: 'Servicios enviados correctamente',
    ZONA_PELIGROSA: 'Recojo en zona con Alta Siniestralidad por Robo reportada por las autoridades. Un operador lo llamará minutos antes del servicio para coordinar un recojo seguro.'

  },
  PROVIDER:
  {
    CULQI: 3,
    PAYU: 1
  },
  ROL:
  {
    ADMIN: 1,
    PARTICULAR: 3,
    ADMIN_CORPORATIVO: 5,
    CORPORATIVO: 6,
    ASISTENTE_CORPORATIVO: 15,
    SUPERVISOR: 13,
    OWNER: -2,
    CORPOREAD:100
  },
  TEXTO_SOLICITAR:{ 
    RESERVA: 'Reserva'
  },
  SOLICITAR_MULTIPUNTO: {
    MJ_LISTA_PERSONAL: "Espere un momento, la lista de personal se esta cargando.",
    MSJ_CLEAR_RUTA: "Solicitar Servicio: No  ha ingresado los campos requeridos.",
    MSJ_LISTA_MARKERS_VACIA: "No ha ingresado el dato de destino.",
    MSJ_USUARIO_TELEFONO: "El número de teléfono no es válido, por favor actualice sus datos.",
    MSJ_TIPO_PAGO: "Seleccione un tipo de pago.",
    MSJ_DETALLE_ENVIO: "Describa su envio.",
    MSJ_CONTACTO_NOMBRE: "Ingrese el nombre del contacto.",
    MSJ_CONTACTO_TELEFONO: "Ingrese el telefono del contacto.",
    MSJ_NO_OBTUVO_CONDUCTOR: "No se encontro conductor.",
    MSJ_MINIMO_LENGTH: "Numero de celular Incorrecto.",
    MSJ_REGISTER_TARJETA: "Su tarjeta ha sido registrada exitosamente",
    MSJ_REGISTRAR_TARJETA: "Por favor espere unos minutos mientras se registra su tarjeta",
    MSJ_TIPO_SERVICIO: "Seleccione un tipo de servicio.",
    MSJ_ID_PASAJERO: "Seleccione un personal de la empresa.",
    MSJ_TELEFONO_PASAJERO: "Ingrese un celular del personal de la empresa.",
    MSJ_LINEA_AEREA: "Ingrese la línea aérea.",
    MSJ_NRO_VUELO: "Ingrese el numero de vuelo.",
    MSJ_NO_PERSONAL: "No se encuentran resultados.",
    MSJ_NO_HA_SELECCIONADO_FECHAS: 'Seleccione fecha para el servicio de rutina',
    MSJ_NO_CENTRO_COSTO: 'No se seleccionó un Centro de Costo',    
    MSJ_SUPERVISORES: 'Autorizado por : ',
    MSJ_LISTA_PERSONAL: 'Espere unos minutos, la lista de personal se esta cargando',
    MSJ_NO_INGRESO_CAMPOS_DINAMICOS: 'El dato de los campos dinamicos requeridos aun no ha sido ingresado',
    MSJ_TIEMPO_RESERVA:'El tiempo mínimo para su reserva es de',
    ERROR: {
      USUARIO_INACTIVO: 'El usuario esta inactivo',
      LST_CENTRO_COSTO_EDITABLE: 'Ocurrio un error, Al cargar los Centros de Costos.',
      CONSURTAR_TARIFA: 'Ocurrio un error, Por favor intente mas tarde.',
      CREAR_SERVICIO: 'Ocurrio un error, Por favor cree un servicio nuevamente.',
      OBTENER_CONDUCTOR: 'Ocurrio un error, Por favor volver a realizar la consulta.',
      CANCELAR_SERVICIO: 'Ocurrio un error, No se pudo cancelar el servicio.',
      TIPO_PAGO: 'Ocurrio un error, Por favor recargar la pagina.',
      TIPO_PAGO_EMPTY: 'Usted no tiene ningun tipo de pago registrado.',
      TIPO_SERVICIO_EMPTY: 'Usted no tiene ningun tipo de servicio registrado.',
      LST_PERSONAL: 'Ocurrio un error, Al cargar la lista del personal.',
      LST_SEDES: 'Ocurrio un error, Al cargar la lista de sedes.',
      SIN_PRESUPUESTO: "No cuenta con presupuesto coordine con su jefe inmediato",
      SIN_DIRECCION: "No se encontro la dirección ingresada",
      VALIDACION_HORARIO: "No se puede realizar el servicio en el horario indicado",
      PRESUPUESTO_INACTIVO: "Presupuesto inactivo, elegir otro tipo de pago",
      EMPRESA_INACTIVA: "Empresa inactiva",
      EMPRESA_PRESUPUESTO_INACTIVO: "Empresa - Presupuesto Inactivo",
      CENTRO_COSTO_INACTIVO: "Centro Costo Inactivo",
      CENTRO_COSTO_PRESUPUESTO_INACTIVO: "Centro costo - Presupuesto Inactivo",
      PRESUPUESTO_INACTIVO_CLIENTE: "Cliente - Presupuesto Inactivo",
      SIN_TARIFA: "No se pudo obtener la tarifa para la ruta ingresada",
      SERVICIO_FECHA_RESERVA_MINIMA: "La hora de la reserva no cumple con el tiempo mínimo para solicitar el servicio",      
      LIMITE_SERVICIO_EXCEDIDO: "Su límite de servicios ha excedido.",
      PRESUPUESTO_PLAZO_INCORRECTO: "El plazo solicitado es incorrecto, máximo 2 días de anticipación",
      NOTA_OBLIGATORIA: "El campo Nota 1 es obligatorio",
      ERROR_RUTINA: "Hubo un incoveniente al crear unos servicios de rutina",
      ERROR_RUTINA_SERVICIOS: "Hubo un inconveniente al crear los servicios, con las fechas: ",
      ERROR_CENTRO_COSTO: "Hubo un inconveniente al crear el servicio; por favor seleccione un centro de costo.",
      ERROR_CONDUCTORES_CERCANOS: 'Ocurrio un error al obtener conductores cercanos, Por favor intente mas tarde.',
    }
  },
  TIPO_EMAIL: {
    NINGUNO: 0,
    NUEVO_CLIENTE: 1,
    FIN_SERVICIO: 2,
    RECUPERAR_CONTRASENIA: 4
  },
  ENVIOS: {
    HABILITAR_TRAZADO: true,
    HABILITAR_TRAZADO_MOBILE:true,
    CONSULTA_ENVIOS: 10000
  },
  MENU: {
    SOLICITAR_SERVICIO: 1,
    USUARIOS: 2,
    ENVIOS: 3,
    METODOS_PAGO: 4,
    MI_EMPRESA: 5,
    MI_CUENTA: 6,
    CERRAR_SESION: 7,
    CENTRO_COSTO: 8
  },
  DOCUMENTO_FISCAL:{
    NOMBRE: 'RUC',
    DESCRIPCION: 'Razon Social'
  },
   

  URL_TIENDA: {
    ANDROID: 'https://play.google.com/store/apps/details?id=com.nexusvirtual.client.alotaxi',
    IOS: 'https://itunes.apple.com/pe/app/aló-taxi-cliente/id1080493426?mt=8',
  },
  APPIDFB: '161912744717854',
  INICIO_FB: false,
  CERRAR_SESION: 7,
  FOTO_ESTRELLA: 'assets/estrellaConductor.png',
  API_KEY_GOOGLE: 'AIzaSyBrcFOAzAD8JZgBYrzLdHFhyWJ8o8dlcSs',
  OPTIMIZEWAYPOINTS: true,
  SHOWPOLIGONO: false,
  MULTIDESTINO: true,
  REGISTRO_CORPORATIVO: false,
  EMPRESA: {
    PARTICULAR: 1,
    INTERBANK : 58
  },
  CENTRO_COSTO: {
    PARTICULAR: 1425
  },
  OPCIONES_DESARROLLO: true
  ,
  CODIGO_PROMOCIONAL: {
    MONEDA_LOCAL: 1,
    PORCENTAJE: 2
  },
  COUNTRY_DEV: {
    HABILITADO: false,
    PAISES: {
      BOLIVIA: {
        HABILITADO: true,
        COORD: {
          LAT: -17.787699,
          LNG: -63.185270
        },
        CODE: 'BO'
      },
      CHILE: {
        HABILITADO: false,
        COORD: {
          LAT: -33.431866,
          LNG: -70.609325
        },
        CODE: 'CL'
      },
      PERU: {
        HABILITADO: false,
        COORD: {
          LAT: -33.431866,
          LNG: -70.609325
        },
        CODE: 'PE'
      }
    }
  },
  CONF_PAIS: {
    PAISES: {
      BOLIVIA: {
        RUC: 'NIT',
        DNI: 'C.I. (Cédula de identidad)',
        REFERENCIA: 'Añada un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'BO'
      },
      CHILE: {
        RUC: 'RUT',
        REFERENCIA: 'Calle y número, Oficina / Piso, Comuna ,Ciudad',

        CODE: 'CL',

      },
      PERU: {
        RUC: 'RUC',
        DNI: 'DNI',
        REFERENCIA: 'Añada un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'PE'

      }
    }
  },
  NOMBRE_EMPRESA: 'Aló Taxi',
  PAGINACION: 5,
  REPORTE_PERSONALIZADO: {
    EMPRESAS: {
      INTERBANK: 58,
      AMERICAN_MOVIL: 5,
      SCOTIA_BANK: 192,
      SCI: 217,
      PACIFICOCYS: 59,
      EPS: 52
    }

  },
  TRUNC_DECIMAL:false,
  CALIFICAR: {
    ACTIVO: true
  },
  ICONS:{
    MOTO:false
   },
  VALIDACIONES_SOLICITAR:{    
    TRUNCAR_TOTAL_SERVICIO: false, 
    RETORNO_ULTIMO_DESTINO: false, 
    ULTIMO_DESTINO_TARIFAR_COMO_PRIMER_DESTINO: false,
    INSTRUCCION_DESTINO:  false,
    REFERENCIA_DESTINO:  true,
    CONTACTO_ADICIONAL: false,
    AEROPUERTO_COMBO_NACIONAL_INTER: false, 
    AEROPUERTO_DETALLES_VUELO: true,
    SELECCIONAR_TIPO_PAGO_DEFECTO: true,
    TIPO_VEHICULO: 'AUTO',
    SOLICITAR_SERVICIO_RUTINA: true,
    LISTAR_CODIGO_PROMOCIONAL: false,
    MODAL_VERIFICACION_DATOS_SERVICIO: false,
    VALIDAR_PEDIR_PARA_OTROS:true,
    VALIDAR_RESTRICCION_PEDIR_SERVICIO:true,
    SOLICITAR_OTRO_SERVICIO:false,
    FAG_AJUSTE_TARIFA:false,
    CANTIDAD_DESTINOS: 30
  },

  PASARELA_PAGO: {
    CULQI: false,
    PAYU: true
  },
  COLOR_ESTADO: {
    LIBRE:'#FFFFFF',// '#00e676',
    ASIGNADO:'#FFE73C',// '#FF9800',
    LEIDO:'#A4FFFF',// '#ff5252',
    UBICADO:'#F5D2AF',// ''
    CONTACTO: '#FFFF80',// '#5c6bc0',
    INICIO: '#AAFFAA',// '#3D5afe',
    LLEGO_DESTINO: '#42A0FF',//'#ef9a9a',
    PENDIENTE: '#26a69a',
    RECHAZADO: '#C0C0C0',//'#d50000',
    OCUPADO:'#4c535a',
    FIN_JORNADA: '#21252921',
    PREASIGNADO: '#FFA8A1',
    ANULADO: '#adb5df',
    SIN_SENIAL: '#e4c2e0',
    APROBADO:{
      APROVADO:'#d50000'
    }
  },
  URL_FOTO_REPORTE:{
    URL_PEAJE: 'https://web.alotaxis.com/PhotoVale/',
    URL_PARQUEO: 'https://web.alotaxis.com/PhotoParqueo/',
    URL_FOTO_CONDUCTOR: 'https://web.alotaxis.com/Photo/',
  },  
  FLAG_SERVICIO_RUTINA: true,
  FLAG_SERVICIO_RETORNO: true,
  APROBACIONES: {
    MSJ_APROBADO: 'El servicio fue aprobado.',
    MSJ_APROBADO_SIN: 'Servicios no enviados.',
    MSJ_RECHAZADO: 'El servicio fue rechazado.',
    MSJ_APROBADO_ANTERIORMENTE: 'El servicio fue aprobado anteriormente.',
    MSJ_RECHAZADO_ANTERIORMENTE: 'El servicio fue rechazado anteriormente.',
    MSJ_FECHA_EXPIRO: 'La fecha del servicio expiró.'
  },
  ESTADO_CONDUCTORES: {
    SINGPS: 0,
    LIBRES:1,
    OCUPADO: 2
  },
  
  TIEMPO_SESION: {
    HABILITAR: true,
    TIEMPO: 120,
    PING: 60,
    TIMEOUT: 3600
  },
  COUNTRY: 'PE',
  DRAG_MARKER : true,
  VALIDAR_NOTIFICACION:true,
  CONFIG_EMPRESA:{
    EMPRESA_PRICE:1473
  }
}


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
